<template>
  <div>
    <el-card title="选择坐标" style="width: 900px;">
      <el-row>
        <div class="amap-page-container">
          <!--<el-amap-search-box class="search-box"-->
                              <!--:on-search-result="onSearchResult"-->
                              <!--:center="center"></el-amap-search-box>-->
          <el-amap :vid="'amap-vue'"
                   :zoom="zoom"
                   :center="center"
                   :events="events">
            <el-amap-marker :position="marker.position" :visible="marker.visible"></el-amap-marker>
          </el-amap>
        </div>
      </el-row>

      <!--<span slot="footer"-->
            <!--class="dialog-footer">-->
      <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
      <!--<el-button type="primary"-->
                 <!--@click="submit">确 定</el-button>-->
    <!--</span>-->
    </el-card>
    <el-card>
      longitude:{{longitude}}<br>
      latitude:{{latitude}}
    </el-card>
  </div>

</template>

<script>
//https://elemefe.github.io/vue-amap
export default {
  data() {
    return {
      q: '',
      zoom: 14,
      longitude:"", // 经度
      latitude:"", // 纬度
      center: [116.602489, 40.080734],
      marker: {
        position: [116.602489, 40.080734],
        // events: {
        //    click: (e) => {
        //      console.log('haha');
        //      this.longitude = e.lnglat.lng;
        //      this.latitude = e.lnglat.lat;
        //      this.marker.position = [e.lnglat.lng, e.lnglat.lat];
        //    },
        //    dragend: (e) => {
        //
        //    }
        // },
        visible: true,
        draggable: false
      },
      events: {
        click: (e) => {
          this.marker.position = [e.lnglat.lng, e.lnglat.lat];
          console.log('haha');
          this.longitude = e.lnglat.lng;
          this.latitude = e.lnglat.lat;
          this.marker.position = [e.lnglat.lng, e.lnglat.lat];
        }
      },
      dialogVisible: false
    }
  },
  methods: {
    open(lng, lat) {
      if (lng && lat) {
        this.center = [lng, lat]
        this.marker.position = [lng, lat]
      }

      this.dialogVisible = true
    },
    onSearchResult(pois) {
      let latSum = 0;
      let lngSum = 0;
      pois.forEach(poi => {
        lngSum += poi.lng;
        latSum += poi.lat;
      });
      let center = {
        lng: lngSum / pois.length,
        lat: latSum / pois.length
      };
      this.center = [center.lng, center.lat];
    },
    submit() {
      this.$emit('callback', this.marker.position)
      this.dialogVisible = false
    }
  }
}
</script>

<style>
  .amap-page-container {
    width: 100%;
    height: 200px;
  }

  .search-box {
    margin-top: 0px;
    position: relative;
    top: 65px;
    left: 20px;
  }
</style>
